module.exports = __webpack_public_path__ + "static/media/FELIPE_SKUPIENcopy.f2ef726e.png";